import {
    Alert,
    AlertDescription,
    AlertTitle,
    Box,
    Card,
    CardBody,
    CardHeader,
    Divider,
    Flex,
    SimpleGrid,
    Text,
} from '@chakra-ui/react';

import { SuccessGreen24Icon, TriangleWarningIcon } from '@assets/icons/index.js';
import { ConditionalComponent } from '@components/functionComponent';
import { useDataKonversi } from '@pages/UploadSellout/hooks/state/useDataKonversi';

import { INFORMATION_COLUMN } from './const';

const SelloutInformation = () => {
    const { sellout_summary } = useDataKonversi();
    const isError = sellout_summary?.total_failed > 0;

    return (
        <>
            <ConditionalComponent
                statement={isError}
                fallback={
                    <Alert
                        status="success"
                        border="1px solid"
                        borderColor="success.500"
                        color="success.800"
                        fontSize="14px"
                    >
                        <Box marginRight={3}>
                            <SuccessGreen24Icon width="24px" height="24px" />
                        </Box>
                        <AlertDescription>
                            Semua informasi dan product telah sesuai dan siap untuk disimpan.
                        </AlertDescription>
                    </Alert>
                }
            >
                <Alert status="error" border="1px solid" borderColor="danger.500" color="danger.800" fontSize="14px">
                    <Box marginRight={3}>
                        <TriangleWarningIcon width="24px" height="24px" />
                    </Box>
                    <AlertTitle>{sellout_summary?.total_failed} Kesalahan pada Data Ditemukan.</AlertTitle>
                    <AlertDescription>
                        Perbaiki dan periksa kembali seluruh informasi sebelum di simpan.
                    </AlertDescription>
                </Alert>
            </ConditionalComponent>

            <Card background="semantic.100" borderRadius="lg">
                <CardHeader as={Flex} flexDirection="column" gap="24px" paddingBottom={0}>
                    <Text fontSize="20px" fontWeight="600">
                        Sellout Information
                    </Text>
                    <Divider />
                </CardHeader>

                <CardBody paddingTop="24px">
                    <SimpleGrid columns={[1, null, 2, 3, 4]} spacing="24px">
                        {INFORMATION_COLUMN.map(({ title, key, value }) => (
                            <Flex
                                key={key}
                                flexDirection="column"
                                gap="4px"
                                borderRadius="md"
                                backgroundColor="white"
                                fontSize="14px"
                            >
                                <Text fontWeight="600">{title}</Text>
                                <Text color={key === 'total_success' ? 'success.600' : 'inherit'}>
                                    {value(sellout_summary[key])}
                                </Text>
                            </Flex>
                        ))}
                    </SimpleGrid>
                </CardBody>
            </Card>
        </>
    );
};

export default SelloutInformation;
